import { activityRepo } from "../mock/repositories";

/** บันทึกลงไทม์ไลน์ลูกค้า — ล้มเหลวไม่กระทบงานหลัก (เช่น ออกเอกสารไปแล้ว) */
export const logActivity = async (orgId, { type = "payment", title, detail = "", customerId = "", customerName = "", amount = null, by = "" }) => {
  try {
    await activityRepo.create(orgId, { type, title, detail, customerId, customerName, amount, by, createdAt: new Date().toISOString() });
  } catch (err) {
    console.warn("บันทึกกิจกรรมไม่สำเร็จ:", err.message);
  }
};
